import { createI18n } from 'vue-i18n'


const messages = {
    en: window.xkit_i18n,
    de: window.xkit_i18n,
}

const i18n = createI18n({
    legacy: false,
    locale: 'en', // set locale
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
})

export default i18n